// extracted by mini-css-extract-plugin
export default {"title":"ListView_title__JcAEX","pesquisa":"ListView_pesquisa__+fUtT","espacamentoBotoes":"ListView_espacamentoBotoes__GLyqu"};